import * as React from 'react';
/**
 * {@docCategory ScrollablePane}
 */
export var ScrollbarVisibility = {
    auto: 'auto',
    always: 'always',
};
export var ScrollablePaneContext = React.createContext({ scrollablePane: undefined });
//# sourceMappingURL=ScrollablePane.types.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/ScrollablePane/ScrollablePane.types.js
// module id = 164
// module chunks = 0